import React, { useEffect } from 'react';
import SectionTitle from '../components/SectionTitle';
import '../styles/About.css';
// import {
//   FaBullseye,
//   FaEye
// } from "react-icons/fa";
import MissionVision from '../components/MissionVision';



function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.fade-up');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) setTimeout(() => e.target.classList.add('visible'), i * 80);
      });
    }, { threshold: 0.12 });
    els.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

// const MV_CARDS = [
//   { icon:  <FaBullseye />, title: 'Our Mission', text: 'To empower individuals with global career opportunities while helping organizations build strong, diverse teams. We are committed to delivering excellence in every placement, every visa, every career counseling session.' },
//   { icon: <FaEye />, title: 'Our Vision',  text: 'To become a leading global HR consultancy known for integrity, efficiency, and success. We envision a world where geography is no barrier to professional excellence and opportunity.' },
// ];

const TEAM = [
  { img: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=500&q=80', name: 'Rajiv Sharma', role: 'Founder & Managing Director'   },
  { img: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=500&q=80', name: 'Priya Nair',   role: 'Head of Global Recruitment'    },
  { img: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=500&q=80', name: 'Arjun Mehta',  role: 'Visa & Immigration Expert'     },
];

const About = ({ onNavigate }) => {
  useReveal();

  return (
    <>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="page-hero-bg" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1600&q=80')" }} />
        <div className="page-hero-content">
          <span className="section-tag">Our Story</span>
          <h1 className="page-hero-title">About <em>Pragya</em><br />HR Solutions</h1>
          <div className="section-line" />
        </div>
      </section>

      {/* Who We Are */}
      <section className="about-body">
        <div className="fade-up">
          <SectionTitle tag="Who We Are" heading="A Legacy of <em>Excellence</em>"   style={{ color: "black" }}/>
          <p>PRAGYA HR CONSULTANCY is a trusted abroad HR consultancy dedicated to connecting skilled professionals with international employers. With years of experience in recruitment, visa assistance, and career guidance, we simplify the complex process of working abroad.</p>
          <p>We believe that every individual deserves the opportunity to build a rewarding international career, and every organization deserves access to world-class talent. Our consultancy was founded on this principle.</p>
          <p>Our team of experienced HR professionals works tirelessly to match the right talent with the right opportunities across the globe, ensuring success for both candidates and employers.</p>
        </div>
        <div className="fade-up">
          <img
            src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=700&q=80"
            alt="About Pragya"
            style={{ width: '100%', height: 380, objectFit: 'cover', filter: 'brightness(0.8)', display: 'block' }}
            loading="lazy"
          />
          <div className="about-body__quote">
            <p>"We bridge the gap between ambition and opportunity — making global careers accessible, efficient, and successful."</p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <MissionVision />

      {/* Team */}
      <section className="team-section">
        <SectionTitle tag="The People Behind Pragya" heading="Our Expert <em>Team</em>" center  style={{ color: "black" }} />
        <div className="team-grid">
          {TEAM.map(member => (
            <div className="team-card fade-up" key={member.name}>
              <img className="team-card__photo" src={member.img} alt={member.name} loading="lazy" />
              <div className="team-card__info">
                <div className="team-card__name">{member.name}</div>
                <div className="team-card__role">{member.role}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <div className="cta-band">
        <p className="cta-text">
          Ready to join thousands of <em>successful</em><br />professionals placed by Pragya?
        </p>
        <button
          className="btn-gold"
          style={{ whiteSpace: 'nowrap', padding: '18px 50px', fontSize: 11 }}
          onClick={() => onNavigate('contact')}
        >
          Contact Us Today
        </button>
      </div>
    </>
  );
};

export default About;